import React from 'react'
import { connect } from 'react-redux'
import { reset } from 'redux-form'
import { Button } from 'reactstrap';

const RemoteResetButton = ({ dispatch , resetData }) => (
  <Button
    type="button"
    onClick={() => { 
      dispatch(reset('third_party_form'));
      resetData();
    }
  }
  >
    Cancelar
  </Button>
)

export default connect()(RemoteResetButton)
